import React, { useEffect, useRef, useState } from "react";
import FormContents from "components/atoms/Form/FormContents";
import BlockUI from "components/molecules/BlockUi";
import GenericTable from "components/organismos/GenericTable/GenericTable";
import SearchPanel from "components/organismos/SearchPanel/SearchPanel";
import AccordionPanel from "components/molecules/AccordionPanel";
import { grayScale } from "components/styles";
import useStoreSalesReportManagement from "components/organismos/master/storeManagement/report/StoreSalesReportManagement/hooks";

const StoreSalesReportManagementLayout = () => {
  const [isExpand, setExpand] = useState(true);

  const {
    headerRows,
    dataRows,
    searchFields,
    handleSearchChange,
    handleDownloadCSV,
    handleDownloadExcel
  } = useStoreSalesReportManagement();

  const searchPanelRef = useRef<HTMLDivElement>(null);
  const [searchPanelHeight, setSearchPanelHeight] = useState<number>(56);

  useEffect(() => {
    if (isExpand === false) {
      setSearchPanelHeight(56);
      return;
    }
    if (searchPanelRef.current) {
      const height = searchPanelRef.current.getBoundingClientRect().height;
      setSearchPanelHeight(height);
    }
  }, [isExpand]);

  return (
    <BlockUI blocking={false}>
      <FormContents>
        {/* 検索パネル */}
        <div ref={searchPanelRef}>
          <AccordionPanel
            text="検索条件"
            color={grayScale.gray100}
            callBack={isExpand => setExpand(isExpand)}
            defaultExpand={isExpand}
          >
            <SearchPanel<any>
              searchFields={searchFields}
              onSearchChange={handleSearchChange}
            />
          </AccordionPanel>
        </div>
        <div style={{ marginTop: "8px" }}>
          <GenericTable
            maxHeight={`calc(100svh - ${searchPanelHeight}px - 110px)`}
            headerRows={headerRows}
            dataRows={dataRows}
            sortable={true}
            showExportExcel={true}
            showExportCSV={true}
            onExportCSV={handleDownloadCSV}
            onExportExcel={handleDownloadExcel}
          />
        </div>
      </FormContents>
    </BlockUI>
  );
};

export default StoreSalesReportManagementLayout;
